import React from 'react';
import { Flex, Text } from 'rebass';

import {
  Container,
  WrappedElements,
  ContainersBox,
  LeftContainer,
  LeftContainerElements,
  LogoContainer,
  RightContainerElements,
  FooterLogo,
} from './styles';
import AffiliateLeftContainer from './components/left-container-affiliate';
import Admin from './components/left-container-admin';
import BgLeftContainer from './components/left-container-backgound';
import { Button } from '@lomadee/design-system';
import { ThemeStore, WhiteLabelStore } from '@plug/redux/store';
import {
  EFIZI_HOST_NAME,
  ESPACO_SMART_HOST_NAME,
  HUNTER_FUN_HOST_NAME,
  IROBOT_HOST_NAME,
  MADESA_HOST_NAME,
  MARY_KAY_WHITELABEL,
  NUTRIBULLET_HOST_NAME,
  OLIST_HOST_NAME,
} from '@plug/config/consts';
import { useMediaQuery } from 'react-responsive';
import OnboardingLogo from './components/onboarding-logo';

interface Props {
  children: React.ReactNode;
  doingAnimation?: boolean;
  name?: string;
  organizationName?: string;
  type?: string;
}
const CreateAccountContainer = ({
  children,
  doingAnimation,
  organizationName,
  type,
}: Props): JSX.Element => {
  const isMobile = useMediaQuery({ maxWidth: '768px' });
  const name = ThemeStore.useState(s => s.organizationName);
  const isOlist = OLIST_HOST_NAME.includes(window.location.hostname);
  const isEfizi = window.location.host.includes('parceiro.efizi');
  const isMaryKay = MARY_KAY_WHITELABEL.includes(window.location.hostname);
  const { isWhiteLabel, logo } = WhiteLabelStore.useState(s => s);

  const OLIST_BACKGROUND_IMAGE =
    'https://plugone-production.nyc3.digitaloceanspaces.com/assets/onboarding-background-image/parceiros.olist.com/backgound.png';

  const OLIST_FOOTER_LOGO =
    'https://plugone-production.nyc3.digitaloceanspaces.com/assets/onboarding-background-image/parceiros.olist.com/footer-logo.png';

  const blockHelpDesk = [
    ...MADESA_HOST_NAME,
    ...EFIZI_HOST_NAME,
    ...OLIST_HOST_NAME,
    ...ESPACO_SMART_HOST_NAME,
    ...MARY_KAY_WHITELABEL,
    ...NUTRIBULLET_HOST_NAME,
    ...IROBOT_HOST_NAME,
    ...HUNTER_FUN_HOST_NAME,
  ].includes(window.location.hostname);

  const hideLogo = [...MADESA_HOST_NAME];

  return (
    <>
      {/* {doingAnimation && <LoginTransition doingAnimation={doingAnimation} name={name} />} */}
      <Flex flexDirection="column" height="100%">
        <Flex justifyContent="space-between" width="100%">
          <ContainersBox>
            <Container>
              <LeftContainer
                olist={isOlist}
                isEfizi={isEfizi}
                style={{
                  position: 'relative',
                  ...(isOlist && {
                    backgroundImage: `url('${OLIST_BACKGROUND_IMAGE}')`,
                    backgroundRepeat: 'round',
                    backgroundSize: 'cover',
                  }),
                }}
              >
                <LogoContainer>
                  {!hideLogo.includes(window.location.host) && <OnboardingLogo />}

                  {!blockHelpDesk && !isOlist && (
                    <Button hierarchy="primary" fluid={false} error={true}>
                      <Text fontSize="14px" fontWeight="600">
                        Ajuda
                      </Text>
                    </Button>
                  )}
                </LogoContainer>

                <WrappedElements>
                  <LeftContainerElements>
                    {type === 'affiliate' && (
                      <AffiliateLeftContainer organizationName={organizationName ?? name} />
                    )}

                    {type === 'admin' && <Admin isOlist={isOlist} />}
                  </LeftContainerElements>

                  {!isOlist && !isEfizi && !isWhiteLabel && !isMaryKay && <BgLeftContainer />}
                </WrappedElements>

                {isOlist && (
                  <FooterLogo>
                    <img
                      style={{ width: '240px' }}
                      src={OLIST_FOOTER_LOGO}
                      alt="Logo da organização"
                    />
                  </FooterLogo>
                )}
              </LeftContainer>
            </Container>

            <Container>
              <RightContainerElements>{children}</RightContainerElements>
            </Container>
          </ContainersBox>
        </Flex>
      </Flex>
    </>
  );
};

export default CreateAccountContainer;
